import { create } from "zustand";
import { RoleType, BusinessType, ServiceType, Commission } from "../components/interfaces";
import { API } from "../utils/axios";

interface MetaState {
  roles: RoleType[];
  businessTypes: BusinessType[];
  serviceTypes: ServiceType[]
  commissionData: Commission[];
  loading: boolean;

  fetchMetaData: () => Promise<void>;
}

export const useMetaStore = create<MetaState>((set) => ({
  roles: [],
  businessTypes: [],
  serviceTypes:[],
  commissionData: [],
  loading: false,

  fetchMetaData: async () => {
    set({ loading: true });

    try {
      const res = await API.get('/business/meta');
      set({
        serviceTypes: res.data.serviceData,
        businessTypes: res.data.businessTypeData,
        roles: res.data.roleData,
        commissionData: res.data.commissionData
      })
      
    } catch (err) {
      console.error("meta store error:", err);
      set({ loading: false });
    }
  },
}));
